export const ProficiencyLevel = {
    Beginner: "Familiar",
    Intermediate: "Proficient",
    Expert: "Advanced"
  };